<!-- eslint-disable -->
<template>
    <div class="search-results overview">
        <div class="search-results__inner overview__inner">
            <form class="searchbar">
                <input @input="onSearchInput" v-model="val" type="search" :placeholder="Drupal.t('sitewide.search.ph')">
                <input v-show="!val.length" @click.prevent="onSubmitButtonClick" type="submit"
                    :value="Drupal.t('sitewide.search.submit')">
                <button v-show="val.length" @click.prevent="onClearClick" class="searchbar__clear">
                    <Icon name="close" />
                </button>
            </form>
            <div v-if="hits.length" class="search-results__results">
                <ul class="search-results__list">
                    <li class="search-results__item views-row" v-for="hit in hits" :key="hit.title">
                        <SearchResult :key="hit.nid" :result="hit" :query="val"/>
                    </li>
                </ul>
                <vs-pagination v-if="nbPages > 1" :total-pages="nbPages" @change="changePage"></vs-pagination>
            </div>
            <div class="overview__empty" v-else-if="val.length && !loading">
                <p>{{ Drupal.t('sitewide.search.empty') }}</p>
            </div>
            <div class="overview__loader" v-else-if="loading">
                <Icon :loading="true" />
            </div>
            <!-- <div v-else class="overview__empty">
                <p>{{ Drupal.t('sitewide.search.ph') }}</p>
            </div> -->
        </div>
    </div>
</template>

<script src="./SearchResults.js"></script>
<style src="./SearchResults.scss" lang="scss"></style>
<!-- eslint-enable -->
